import React from 'react';
import {Route} from 'react-router-dom';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';
import AsyncPage from './async';

export default (
  <Route key="/consumer/features/colorize-black-and-white-photos" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/colorize-black-and-white-photos" element={<AsyncPage />} />
  </Route>
);
